import { Link } from 'react-router-dom';
import CompanyAddress from '../components/CompanyAddress';
import {
  COMPANY_NAME,
  FOOTER_DISCLAIMER,
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
  SUPPORT_PHONE_TEL,
} from '../constants/site';

export default function PolicyLayout({
  title,
  updated,
  intro,
  children,
  showDisclaimer = true,
}) {
  return (
    <>
      <section className="fm-policy-hero">
        <div className="fm-container">
          <p className="fm-policy-crumbs">
            <Link to="/">Home</Link>
            <span aria-hidden>/</span>
            <span>{title}</span>
          </p>
          <h1>{title}</h1>
          <p className="fm-policy-updated">Last updated: {updated}</p>
        </div>
      </section>

      <section className="fm-policy-body">
        <div className="fm-container fm-container--narrow">
          <div className="fm-policy-card">
            {intro && <p className="fm-policy-intro">{intro}</p>}
            {children}

            <h2>Contact &amp; registered office</h2>
            <p>
              This website is operated by <strong>{COMPANY_NAME}</strong>.
              Written notices and formal requests relating to this policy should
              be sent to the registered office below.
            </p>
            <div className="fm-policy-address">
              <CompanyAddress />
              <div className="fm-policy-address__links">
                <a href={`tel:${SUPPORT_PHONE_TEL}`}>{SUPPORT_PHONE}</a>
                <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
              </div>
            </div>

            {showDisclaimer && (
              <>
                <h2>Disclaimer</h2>
                {FOOTER_DISCLAIMER.map((paragraph) => (
                  <p key={paragraph.slice(0, 48)}>{paragraph}</p>
                ))}
              </>
            )}

            <div className="fm-policy-note">
              <p>
                <strong>Questions about this policy?</strong> Email{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> or call{' '}
                <a href={`tel:${SUPPORT_PHONE_TEL}`}>{SUPPORT_PHONE}</a>. We
                respond to written enquiries within two business days.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
